/**
 * @file     siteNotice.ts
 * @readme   ../../CLAUDE.md
 * @purpose  English strings for the site notice (cookie choice plus the DDF
 *           Rule 6(d)(ii) browse-wrap) and the cookie preferences panel. The
 *           terms* strings carry the browse-wrap statement and must not be
 *           edited without a compliance review.
 */
export const siteNotice = {
  label: 'Cookies and listing terms',
  cookiesBefore: 'Relta uses ',
  cookiesLink: 'cookies',
  cookiesAfter: ' for analytics and ads.',
  termsBefore: 'By using this site you agree to the ',
  termsLink: 'MLS® listing terms',
  termsAfter: '.',
  gpcNotice: 'Ads stay off: your browser sends Global Privacy Control.',
  decline: 'Decline',
  accept: 'Accept',
  preferencesLink: 'Preferences',
  agree: 'I agree',
  preferences: {
    title: 'Cookie preferences',
    alwaysOn: 'Always on',
    essentialTitle: 'Essential',
    essentialBody: "Sign-in, security, and Relta's own record of listings you view.",
    analyticsTitle: 'Analytics',
    analyticsBody: 'Google Analytics, to see which pages are useful.',
    marketingTitle: 'Advertising',
    marketingBody: 'Google Ads and Meta Pixel, to measure ads.',
    marketingGpc: 'Off: your browser sends Global Privacy Control.',
    termsAck: 'Saving also confirms you agree to the MLS® listing terms.',
    save: 'Save',
    acceptAll: 'Accept all',
    close: 'Close',
  },
  footerLink: 'Cookie preferences',
} as const;
